import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { Compteur, CompteurState } from './state';
import { Component } from 'vue';
import regex from '@/common/utils/Regex';

export const getters: GetterTree<CompteurState, RootState> = {
    getCompteurStep(state): number {
        return state.step;
    },
    getRaisonSociale(state): string {
        return state.raisonSociale;
    },
    getNomCommercial(state): string {
        return state.nomCommercial;
    },
    getNumeroIdentification(state): string {
        return state.numeroIdentifiant;
    },
    getAdressePostale(state): string {
        return state.adressePostale;
    },
    getCodePostal(state): number | undefined {
        return state.codePostal;
    },
    getVille(state): string {
        return state.ville;
    },
    getCivilite(state) : string {
        return state.civilite;
    },
    getNomRepresentant(state) : string {
        return state.nomRepresentant;
    },
    getPrenomRepresentant(state) : string {
        return state.prenomRepresentant;
    },
    getDateNaissanceRepresentant(state) : string{
        return state.dateNaissanceRepresentant;
    },
    getEmailRepresentant(state) : string {
        return state.emailRepresentant;
    },
    getAdresseIdentique(state) : boolean {
        return state.adresseRepresentantIdentique;
    },
    getAdressePostaleRepresentant(state): string {
        return state.adresseRepresentant;
    },
    getCodePostalRepresentant(state): number | undefined {
        return state.codePostalRepresentant;
    },
    getVilleRepresentant(state): string {
        return state.villeRepresentant;
    },
    getCompteurs(state): Compteur[] | undefined {
        return state.compteurs;
    },
    getCompteur(state, index: number) : Compteur | undefined {
        if (state.compteurs === undefined) {
            return undefined;
        }
        return state.compteurs[index];
    },
    isCompteurFormValid(state): boolean {
        switch (state.step) {
            case 0:
                return (
                  state.raisonSociale.trim() !== '' &&
                  state.nomCommercial.trim() !== '' &&
                  state.numeroIdentifiant.trim() !== '' &&
                  state.adressePostale.trim() !== '' &&
                  (state.codePostal !== undefined && String(state.codePostal) !== '') &&
                  state.ville.trim() !== '');
            case 1:
                return (
                    state.nomRepresentant.trim() !== '' &&
                    state.prenomRepresentant.trim() !== '' &&
                    state.dateNaissanceRepresentant !== null &&
                    regex.mail().test(state.emailRepresentant) &&
                    (state.adresseRepresentantIdentique ||
                      (state.adresseRepresentant.trim() !== '' &&
                        (state.codePostalRepresentant !== undefined && String(state.codePostalRepresentant) !== '') &&
                        state.villeRepresentant !== '')
                    )
                );
            case 2:
                return (
                    state.compteurs === undefined ? false :
                        state.compteurs.length > 1 ||
                        state.compteurs[0].numeroCompteur.trim() !== '' || state.compteurs[0].facture !== undefined);
            default:
                return false;
        }
    },
    getCurrentStep(state): Component {
        return state.steps[state.step];
    },
    getForm(state): CompteurState {
        return state;
    },
};
